import type { MutableRefObject } from 'react';
import { createContext, useContext } from 'react';
import type { UIPayment, UIPayout } from 'store/formatters/commonPayments';

import type { CurrencyChangeReason, HandleCurrencyProps } from './AppCoreProvider';

export interface AppCoreContextProps<T = UIPayment | UIPayout> {
  widgetData: {
    data: T;
    isLoading: boolean;
    refetchInit: (value?: string) => void;
  };
  selectState: {
    setIsSelectGroupRequestDoneRef: (value: boolean | null) => void;
    isSelectGroupRequestDoneRef: MutableRefObject<boolean | null>;
  };
  methodsPageState: {
    isInitialMethodsPageInitializedRef: MutableRefObject<boolean | null>;
    setIsInitialMethodsPageInitializedRef: (value: boolean) => void;
  };
  handleCurrencyChange: (props: HandleCurrencyProps) => void;
  currencyChangeReasonRef: MutableRefObject<CurrencyChangeReason | null>;
  setCurrencyChangeReason: (reason: CurrencyChangeReason | null) => void;
  resetFlowState: () => void;
  isInitialInitDoneRef: MutableRefObject<boolean>;
}

export const AppCoreContext = createContext<AppCoreContextProps | null>(null);

export const useAppCore = () => {
  const context = useContext(AppCoreContext);
  if (!context) {
    throw new Error('useAppCore must be used within AppCoreProvider');
  }
  return context;
};
